// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-input{display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/components/VerificationScreen/verification.scss"],"names":[],"mappings":"AACA,YACI,YAAA,CACA,qBAAA","sourcesContent":["@import \"/src/theme/mixin.scss\"; \r\n.code-input {\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
